import React, { Component } from 'react'
import api from '../api/api.js'

import { withStyles } from '@mui/styles';
import {
	AppBar,
	Button,
	Card,
	CardActions,
	CardContent,
	CircularProgress,
	Dialog,
	Grid,
	Input,
	IconButton,
	Slide,
	TextField,
	Toolbar,
	Typography, 
	Tooltip
} from '@mui/material';
import { DialogTitle } from '@mui/material';
import { DialogContent } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CloseIcon from '@mui/icons-material/Close';

import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { authMiddleWare } from '../util/auth';



const styles = (theme) => ({
	content: {
		flexGrow: 1,
		padding: theme.spacing(3)
	},
	appBar: {
		position: 'relative'
	},
	title: {
		marginLeft: theme.spacing(2),
		flex: 1
	},
	submitButton: {
		display: 'block',
		color: 'white',
		textAlign: 'center',
		position: 'absolute',
		right: 10
	},
	floatingButton: {
		position: 'fixed',
		bottom: 0,
		right: 0
	},
	form: {
		width: '98%',
		marginLeft: 13,
		marginTop: theme.spacing(3)
	},
  input: {
    marginBottom: 20
  },
	toolbar: theme.mixins.toolbar,
	root: {
		background: 'linear-gradient(90deg, #e6e1d790 10%, #e6e1d790 10%)',
		minWidth: 470
	},
	bullet: {
		display: 'inline-block',
		margin: '0 2px',
		transform: 'scale(0.8)'
	},
	pos: {
		marginBottom: 12
	},
	uiProgress: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	},
	dialogeStyle: {
		maxWidth: '50%'
	},
	viewRoot: {
		margin: 0,
		padding: theme.spacing(2)
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500]
	}
});


const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" {...props} ref={ref}  />;
});

class todo extends Component {
	constructor(props) {
		super(props);

		this.state = {
			todos: '',
			title: '',
			body: '',
			todoId: '',
			errors: [],
			open: false,
			uiLoading: true,
			buttonType: '',
			viewOpen: false,
      filter: '',
		};

		this.deleteTodoHandler = this.deleteTodoHandler.bind(this);
		this.handleEditClickOpen = this.handleEditClickOpen.bind(this);
		this.handleViewOpen = this.handleViewOpen.bind(this);
	}

	componentDidMount = async () => {
		authMiddleWare(this.props.history);
		try {
			const response = await api.get('/todos')
			this.setState({
				todos: response.data,
				uiLoading: false
			});
		} catch (error) {
				if (error.response.status === 403) {
					this.props.history.push('/login');
				}
				console.log(error);
		}
	};

	deleteTodoHandler = async (data) => {
		try {
			let todoId = data.todo.todoId
			this.setState({uiLoading:true})
			await api.delete(`/todo/${todoId}`)
			const todos = [...this.state.todos.filter(todo => todo.todoId !== todoId)]
				this.setState({uiLoading:false, todos})
		} catch (error) {
			if (error.response.status === 403) {
				this.props.history.push('/login');
			}
			this.setState({uiLoading:false})
			console.log(error)
		}
	}

	handleEditClickOpen(data) {
		this.setState({
			title: data.todo.title,
			body: data.todo.body,
			todoId: data.todo.todoId,
			buttonType: 'Edit',
			open: true
		});
	}

	handleViewOpen(data) {
		this.setState({
			title: data.todo.title,
			body: data.todo.body,
			viewOpen: true
		});
	}

	handleSubmit = async (event) => {
		event.preventDefault();
		authMiddleWare(this.props.history);

		this.setState({ uiLoading: true });

		const { title, body, buttonType, todoId } = this.state;
		const userTodo = { title, body };

		try {
			let todos;

			if (buttonType === 'Edit') {
				await api.put(`/todo/${todoId}`, userTodo);

				todos = this.state.todos.map((todo) =>
					todo.todoId === todoId
						? { ...todo, title, body }
						: todo
				);
			} else {
				const response = await api.post('/todo', userTodo);
				todos = [...this.state.todos, response.data];
			}

			this.setState({
				open: false,
				todos,
				uiLoading: false,
			});
		} catch (error) {
			if (error.response?.status === 403) {
				this.props.history.push('/login');
				return;
			}

			this.setState({
				open: true,
				errors: error.response?.data,
				uiLoading: false,
			});

			console.error(error);
		}
	};

	handleChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		});
	};

	handleClickOpen = () => {
		this.setState({
			todoId: '',
			title: '',
			body: '',
			buttonType: '',
			open: true
		});
	};

	handleViewClose = () => {
		this.setState({ viewOpen: false });
	};

	handleClose = () => {
		this.setState({ open: false });
	};

	handleFilter = (event) => {
			this.setState({ filter:event.target.value});
	};


	render() {
		dayjs.extend(relativeTime);
		const { classes } = this.props;
		const { open, errors, viewOpen } = this.state;


		if (this.state.uiLoading === true) {
			return (
				<main className={classes.content}>
					<div className={classes.toolbar} />
					{this.state.uiLoading && <CircularProgress size={150} className={classes.uiProgress} />}
				</main>
			);
		} else {
			return (
                <main className={classes.content}>
					<div className={classes.toolbar} />
						<Tooltip title="Add a new todo" placement="top">
							<IconButton
								className={classes.floatingButton}
								color="primary"
								aria-label="Add Message"
								onClick={this.handleClickOpen}
								size="large"
							>
								<AddCircleIcon style={{ fontSize: 60 }} />
							</IconButton>
						</Tooltip>
            <Input id="Todo-Filter" placeholder="FilterElement" variant="filled" onChange={this.handleFilter}/>

          <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
						<AppBar position="static">
              <Toolbar variant="dense">
								<Tooltip title="Close Modal" placement="top">
									<IconButton
										edge="start"
										color="inherit"
										onClick={this.handleClose}
										aria-label="close"
										size="large"
									>
										<CloseIcon />
									</IconButton>
								</Tooltip>
								<Typography variant="h6" className={classes.title}>
									{this.state.buttonType === 'Edit' ? 'Edit Message' : 'Create a message'}
								</Typography>
								<Button
									autoFocus
									color="inherit"
									onClick={this.handleSubmit}
									className={classes.submitButton}
								>
									{this.state.buttonType === 'Edit' ? 'Save' : 'Submit'}
								</Button>
							</Toolbar>
						</AppBar>

						<form className={classes.form} noValidate>
							<Grid container spacing={2}>
								<Grid item xs={12}>
									<TextField
										variant="outlined"
										required
										fullWidth
										id="todoTitle"
										label="Todo Title"
										name="title"
										autoComplete="todoTitle"
										helperText={errors.title}
										value={this.state.title}
										error={errors.title ? true : false}
										onChange={this.handleChange}
									/>
								</Grid>
								<Grid item xs={12}>
									<TextField
										variant="outlined"
										required
										fullWidth
										id="todoDetails"
										label="Todo Details"
										name="body"
										autoComplete="todoDetails"
										multiline
										minRows={25}
										maxRows={25}
										helperText={errors.body}
										error={errors.body ? true : false}
										onChange={this.handleChange}
										value={this.state.body}
									/>
								</Grid>
							</Grid>
						</form>
					</Dialog>

{/* Normal todo cards view */}
					<Grid container spacing={2}>
						{this.state.todos.map( (todo) => 
              todo.title.includes(this.state.filter) ? (
							<Grid item xs={12} sm={6}>
								<Card className={classes.root} variant="outlined">
									<CardContent>
										<Typography variant="h6" component="h2">
											{todo.title}
										</Typography>
										<Typography className={classes.pos} color="textSecondary">
											{dayjs(todo.createdAt).fromNow()}
										</Typography>
										<Typography variant="h7" component="h4">
											{'by ' + this.props.username}
										</Typography>
										<Typography variant="body2" component="p">
											{`${todo.body.substring(0, 25)}`}
										</Typography>
									</CardContent>
									<CardActions>
										<Button size="small" color="primary" onClick={() => this.handleViewOpen({ todo })}>
											{' '}
											View{' '}
										</Button>
										<Button size="small" color="primary" onClick={() => this.handleEditClickOpen({ todo })}>
											Edit
										</Button>
										<Button size="small" color="primary" onClick={() => this.deleteTodoHandler({ todo })}>
											Delete
										</Button>
									</CardActions>
								</Card>
							</Grid>
						) :null )}
					</Grid>

{/* Dialog-Modal View single Todo: */}
					<Dialog
						onClose={this.handleViewClose}
						aria-labelledby="customized-dialog-title"
						open={viewOpen}
						fullWidth
						classes={{ paperFullWidth: classes.dialogeStyle }}
					>
						<DialogTitle id="customized-dialog-title" onClose={this.handleViewClose}>
							{this.state.title}
						</DialogTitle>
						<DialogContent dividers>
							<TextField
								fullWidth
								id="todoDetails"
								name="body"
								multiline
								readonly
								minRows={1}
								maxRows={25}
								value={this.state.body}
								InputProps={{
									disableUnderline: true
								}}
							/>
						</DialogContent>
					</Dialog>
				</main>
            );
		}
	}
}

export default withStyles(styles)(todo);